import { VISITOR_RECORDED_STORAGE_KEY } from './visitor-recorded-storage-key';

export function markVisitorRecorded(key: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(
      VISITOR_RECORDED_STORAGE_KEY,
      JSON.stringify({ key, at: Date.now() }),
    );
  } catch {
    // localStorage unavailable (private mode / quota); skip the guard, recording still works.
  }
}
